import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { environment } from "src/environments/environment";

@Injectable()
export class AuthService {
  helper: JwtHelperService;

  constructor() {
    this.helper = new JwtHelperService();
  }

  get isAuthenticated() {
    return !this.helper.isTokenExpired(localStorage.getItem(environment.ProjectName+"-token"));
    // return !this.helper.isTokenExpired(localStorage.getItem("token"));
    // if(localStorage.getItem('token')){
    //     return true;
    // }else{
    //     return false;
    // }
  }
  getUserName() {
    return this.helper.decodeToken(localStorage.getItem(environment.ProjectName+"-token"));
    // return this.helper.decodeToken(localStorage.getItem("token"));
  }
}
